import { useMutation } from '@tanstack/react-query';

import { scoutClient } from '@/modules/scout-sourcing/scoutClient';
import type { ScoutStartResponse } from '@/modules/scout-sourcing/types';

type Payload = {
  jobId: string;
  prompt: string;
};

export const useStartScoutMutation = () =>
  useMutation<ScoutStartResponse, Error, Payload>({
    mutationFn: ({ jobId, prompt }) => scoutClient.start(jobId, prompt),
  });
